(function () {
  window.CushyBumOfferRules = {
    giftVariants: {
      carryBag: '52936351514934',
      cushyBundle: '52936843559222'
    },
    cartWideGifts: {
      standardBagThreshold: 2,
      eofyBagThreshold: 1,
      bundleThreshold: 3
    },
    offers: [
      {
        id: 'standard-cushy-bum',
        label: 'Cushy Bum standard offer',
        // Default offer for EVERY Cushy Bum product. Any product whose handle
        // contains one of these fragments is treated as a standard Cushy Bum,
        // so duplicates / new variants automatically inherit the same deal.
        handleIncludes: ['cushy-bum'],
        productHandles: ['inflatable-travel-pillow'],
        variantIds: ['51849753264438'],
        // Add a variant ID here to opt a specific Cushy Bum OUT of the auto offer.
        excludeVariantIds: [],
        tiers: [
          {
            minQuantity: 1,
            carryBagsPerUnit: 0,
            cushyBundleQuantity: 0,
            note: '1 Cushy Bum has no free gift.'
          },
          {
            minQuantity: 2,
            carryBagsPerUnit: 1,
            cushyBundleQuantity: 0,
            note: '2 Cushy Bums unlock 2 free carry bags.'
          },
          {
            minQuantity: 3,
            carryBagsPerUnit: 1,
            cushyBundleQuantity: 1,
            note: '3 Cushy Bums unlock 3 free carry bags and 1 free Cushy Bundle.'
          }
        ]
      },
      {
        id: 'eofy-cushy-bum',
        label: 'Cushy Bum EOFY offer',
        productHandles: [],
        variantIds: ['54074976567606'],
        tiers: [
          {
            minQuantity: 1,
            carryBagsPerUnit: 1,
            cushyBundleQuantity: 0,
            note: 'EOFY offer includes 1 free carry bag from the first Cushy Bum.'
          },
          {
            minQuantity: 3,
            carryBagsPerUnit: 1,
            cushyBundleQuantity: 1,
            note: '3 EOFY Cushy Bums unlock 3 free carry bags and 1 free Cushy Bundle.'
          }
        ]
      }
    ]
  };
})();
